// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__2r0Ua","attendeeChip":"styles_attendeeChip__1cqnB","attendeeChipText":"styles_attendeeChipText__1tC2r"};